import React, { createContext, useState, useEffect, useContext } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Nếu đang ở browser, lấy giá trị từ localStorage, nếu không thì mặc định là 'vi'
    if (typeof window !== 'undefined') {
      return localStorage.getItem('cmsLanguage') || 'vi';
    }
    return 'vi';
  });
  
  // Đồng bộ state với localStorage khi language thay đổi
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('cmsLanguage', language);
    }
  }, [language]);
  
  const changeLanguage = (lang) => {
    setLanguage(lang);
  };
  
  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}; 